import { Trash2 } from "lucide-react";
import { useEffect, useState } from "react";
import t from "@/lang/lang";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { CommonDialogFooter } from "@/shared/components/ui/dialog-common";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import { useAuthFeatureAuthDeleteMutation } from "../services/feature-auth";

export function FeatureAuthDeleteDialog({ feature }: { feature: string }) {
  const [open, setOpen] = useState(false);
  const [del, { isLoading, error, isSuccess, reset }] =
    useAuthFeatureAuthDeleteMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      setOpen(false);
    }
  }, [isSuccess, reset]);

  const doDelete = () => {
    if (isLoading) return;
    del({ feature });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="destructive">
          <Trash2 />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("Feature Authorisierungsregel wirklich löschen?")}
          </DialogTitle>
          <DialogDescription>{t("Regel wird gelöscht")}</DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
